import { createFileRoute, redirect } from '@tanstack/react-router'

import { postLoginRedirect } from '@/shared/auth/post-login-redirect'
import { useAuthStore } from '@/shared/auth/stores/authStore'
import { notificationsQueryOptions } from '@/shared/hooks/useNotifications'
import { NotificationsFeedPage } from '@/systems/notifications/features/notifications-feed/components/NotificationsFeedPage'

// Self-feed for /notifications. Available to any authenticated role —
// admin / super_admin / HOD reach it via the bell-icon "View all" link.
// FOs are redirected to /mobile-only by the global guard before
// they could ever click the link.
export const Route = createFileRoute('/notifications')({
  beforeLoad: () => {
    const state = useAuthStore.getState()
    if (!state.isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    const role = state.user?.role_name
    if (role === 'field_officer') {
      throw redirect({ to: postLoginRedirect(role) })
    }
  },
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(
      notificationsQueryOptions({ page: 1, page_size: 20 }),
    )
  },
  component: NotificationsFeedPage,
})
